import { withFieldConfigLayoutTabs } from "../components/withFieldConfigLayoutTabs.js";
import "react";
import { Checkbox, FormLayout, Text } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Textarea/Config.tsx
var TextareaFieldConfig = withFieldConfigLayoutTabs(({ config, layoutType, setMultipleOptionsKeys, setOptions, setOptionsKey }) => {
	if (layoutType === "Display") return /* @__PURE__ */ jsx(FormLayout, {
		space: "sm",
		children: /* @__PURE__ */ jsx(Text, {
			onChangeValue: (value) => setOptionsKey("displayLabel", value),
			label: "Label",
			value: config.options.displayLabel
		})
	});
	return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(FormLayout, {
		space: "sm",
		children: [
			/* @__PURE__ */ jsx(Text, {
				onChangeValue: (value) => {
					if (config.options.displayLabel === config.options.formLabel) setMultipleOptionsKeys([["formLabel", value], ["displayLabel", value]]);
					else setOptionsKey("formLabel", value);
				},
				label: "Label",
				value: config.options.formLabel
			}),
			/* @__PURE__ */ jsx(Text, {
				onChangeValue: (value) => setOptionsKey("subText", value),
				label: "Sub Text",
				value: config.options.subText
			}),
			/* @__PURE__ */ jsx(Checkbox, {
				active: !!config.options.required,
				label: "Required",
				onChangeValue: (active) => setOptionsKey("required", active),
				subText: "Make this a required field"
			})
		]
	}) });
});
//#endregion
export { TextareaFieldConfig };

//# sourceMappingURL=Config.js.map